import React from 'react';
import { Box, Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';

import Toolbar from './Toolbar';
import AmortizationBalanceListTabs from './AmortizationBalanceListTabs';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const AmortizationBalanceListView = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Page className={classes.root} title={t('NAVIGATION.AMORTIZATION_BALANCE')}>
      <FadeIn transitionDuration={200}>
        <Container maxWidth={false}>
          <Toolbar />
          <Box mt={3}>
            <AmortizationBalanceListTabs />
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

export default AmortizationBalanceListView;
